module.exports = __webpack_public_path__ + "static/media/Hair_3_dark_brown.868c898c.svg";